import axios from 'axios';
import {getApiBaseUrl} from '../utils/getApiBaseUrl';
import secureStorage from "../utils/secureStorage";

const API_URL = getApiBaseUrl();


// Crear una instancia de Axios
const api = axios.create({
  baseURL: API_URL,
});

// Configurar un interceptor para agregar el token a cada solicitud
api.interceptors.request.use(
  (config) => {
    // Obtener el token del localStorage
    const token = secureStorage.getItem('authToken');
    
    if (token) {
      // Agregar el token al encabezado de autorización
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

const getDescuentoSanciones = async (id) => {
  try {
    const response = await api.get(`${API_URL}descuento/descuentoView`);
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener datos del backend:', error);
  }
};

const getDescuento = async () => {
  try {
    const token = secureStorage.getItem('authToken');
    const response = await axios.get(`${API_URL}descuento/descuentoView`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    // Filtrar los datos para excluir los elementos con id_descuento 3
    const filteredResponseData = response.data.filter(
      (item) => item.id_descuento !== 3
    );
    
    return filteredResponseData;
  } catch (error) {
    console.error("Error al obtener datos del backend:", error);
    return []; // Devuelve un array vacío en caso de error
  }
};

const getListTruckView = async () => {
  try {
    const response = await api.get('truck/listTruckView');
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener datos del backend: ' + error.message);
  }
};

const getOneDescuento = async (id) => {
  try {
    const response = await api.get(`${API_URL}descuento/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener datos del backend:', error);
  }
};

const PostDatosDescuento = async (datos) => {
  try {
    const response = await api.post(`descuento`, datos);

    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      // Si el error es una respuesta del servidor con un mensaje de error
      throw new Error('Error al enviar datos al backend: ' + error.response.data.message);
    } else {
      // Si el error no es una respuesta del servidor con un mensaje de error
      throw new Error('Error al enviar datos al backend: ' + error.message);
    }
  }
};

export { getDescuento, PostDatosDescuento, getOneDescuento, getListTruckView, getDescuentoSanciones };